import { color as themeColor } from "@styles";

export const Check = ({ className, color, ...props }: { className?: string; color?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7864 3.51098C14.0565 3.7612 14.0726 4.183 13.8224 4.4531L6.41132 12.4531C6.2842 12.5903 6.1053 12.6678 5.91825 12.6667C5.73121 12.6656 5.55325 12.5859 5.42779 12.4472L2.17221 8.8472C1.92525 8.57412 1.94643 8.15254 2.21951 7.90558C2.4926 7.65862 2.91418 7.6798 3.16114 7.95289L5.92818 11.0127L12.8443 3.54698C13.0945 3.27688 13.5163 3.26076 13.7864 3.51098Z"
      fill={color || themeColor.S3100}
    />
  </svg>
);
